module.exports = __webpack_public_path__ + "img/FPT17.bbaa0676.svg";